import { render, staticRenderFns } from "./MsKhachDuLichRegister.vue?vue&type=template&id=f94d7ec0&"
import script from "./MsKhachDuLichRegister.vue?vue&type=script&lang=js&"
export * from "./MsKhachDuLichRegister.vue?vue&type=script&lang=js&"
import style0 from "./MsKhachDuLichRegister.vue?vue&type=style&index=0&id=f94d7ec0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports